<template>
<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-yujingtongzhi`]" width="1em" height="1em" v-bind="$attrs"><path d="M9 6.2V9M9 12H9.00833M6.102 2H11.898L16 6.102V11.898L11.898 16H6.102L2 11.898V6.102L6.102 2Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconYujingtongzhi',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
